export const stateData = [
    { value: "AB", label: "Alberta", query: "state" },
    { value: "AL", label: "Alabama", query: "state" },
    { value: "AK", label: "Alaska", query: "state" },
    { value: "AZ", label: "Arizona", query: "state" },
    { value: "AR", label: "Arkansas", query: "state" },
    { value: "AS", label: "American Samoa", query: "state" },

    { value: "BC", label: "British Columbia", query: "state" },

 
    { value: "CA", label: "California", query: "state" },
    { value: "CO", label: "Colorado", query: "state" },
    { value: "CT", label: "Connecticut", query: "state" },
    { value: "DE", label: "Delaware", query: "state" },
    { value: "DC", label: "District of Columbia", query: "state" },
    { value: "FL", label: "Florida", query: "state" },
    { value: "GA", label: "Georgia", query: "state" },
    { value: "GU", label: "Guam", query: "state" },

    { value: "HI", label: "Hawaii", query: "state" },
    { value: "ID", label: "Idaho", query: "state" },
    { value: "IL", label: "Illinois", query: "state" },
    { value: "IN", label: "Indiana", query: "state" },
    { value: "IA", label: "Iowa", query: "state" },
    { value: "KS", label: "Kansas", query: "state" },
    { value: "KY", label: "Kentucky", query: "state" },
    { value: "LA", label: "Louisiana", query: "state" },
    { value: "ME", label: "Maine", query: "state" },
    { value: "MD", label: "Maryland", query: "state" },
    { value: "MA", label: "Massachusetts", query: "state" },
    { value: "MI", label: "Michigan", query: "state" },
    { value: "MN", label: "Minnesota", query: "state" },
    { value: "MS", label: "Mississippi", query: "state" },
    { value: "MO", label: "Missouri", query: "state" },
    { value: "MT", label: "Montana", query: "state" },
    { value: "NE", label: "Nebraska", query: "state" },
    { value: "NV", label: "Nevada", query: "state" },
    { value: "MB", label: "Manitoba", query: "state" },
    { value: "NB", label: "New Brunswick", query: "state" },
    { value: "NL", label: "Newfoundland and Labrador", query: "state" },
    { value: "NT", label: "Northwest Territories", query: "state" },
    { value: "NS", label: "Nova Scotia", query: "state" },
    { value: "NU", label: "Nunavut", query: "state" },
    { value: "NH", label: "New Hampshire", query: "state" },
    { value: "NJ", label: "New Jersey", query: "state" },
    { value: "NM", label: "New Mexico", query: "state" },
    { value: "NY", label: "New York", query: "state" },
    { value: "NC", label: "North Carolina", query: "state" },
    { value: "ND", label: "North Dakota", query: "state" },
    { value: "MP", label: "Northern Mariana Islands", query: "state" },
    { value: "OH", label: "Ohio", query: "state" },
    { value: "ON", label: "Ontario", query: "state" },
    { value: "OK", label: "Oklahoma", query: "state" },
    { value: "OR", label: "Oregon", query: "state" },
    { value: "PA", label: "Pennsylvania", query: "state" },
    { value: "PE", label: "Prince Edward Island", query: "state" },
    { value: "PR", label: "Puerto Rico" },
    { value: "QC", label: "Quebec", query: "state" },
    { value: "RI", label: "Rhode Island", query: "state" },
    { value: "SC", label: "South Carolina", query: "state" },
    { value: "SD", label: "South Dakota", query: "state" },
    { value: "SK", label: "Saskatchewan", query: "state" },
    { value: "TN", label: "Tennessee", query: "state" },
    { value: "TX", label: "Texas", query: "state" },
    { value: "UT", label: "Utah", query: "state" },
    { value: "VT", label: "Vermont", query: "state" },
    { value: "VA", label: "Virginia", query: "state" },
    { value: "WA", label: "Washington", query: "state" },
    { value: "WV", label: "West Virginia", query: "state" },
    { value: "WI", label: "Wisconsin", query: "state"   },
    { value: "WY", label: "Wyoming", query: "state" },
    { value: "VI", label: "U.S. Virgin Islands" },
    { value: "YT", label: "Yukon", query: "state" },

  ];